module.exports = __webpack_public_path__ + "img/krotoski-bialoleka.0f8091f9.jpg";